import { ToastError } from "components/Global/Toasts/Toasty";
import { put, takeLatest } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload, multipleObjectReturn, requestSaga } from "shared-utility/store/utils/helpers";

// ACTIONS

export const SET_NOI_CALC_SELECTIONS = generateDefaultActions("SET_NOI_CALC_SELECTIONS");
export const setNoiCalculationsDashboardSelections = payload => makeWritePayload(SET_NOI_CALC_SELECTIONS.value, payload);

export const SET_DEFAULT_NOI_CALC_SELECTIONS = generateDefaultActions("SET_DEFAULT_NOI_CALC_SELECTIONS");
export const setDefaultNoiDashboardSelections = () => makeWritePayload(SET_DEFAULT_NOI_CALC_SELECTIONS.value);

export const SET_FIELD_UPDATED_FLAG = generateDefaultActions("SET_FIELD_UPDATED_FLAG");
export const setFieldUpdatedFlag = () => makeWritePayload(SET_FIELD_UPDATED_FLAG.value);

export const GET_NOI_CALC_BY_REPORT_COMPONENT_ID = generateDefaultActions("GET_NOI_CALC_BY_REPORT_COMPONENT_ID");
export const getNoiCalcByReportComponentId = payload => makePayload(GET_NOI_CALC_BY_REPORT_COMPONENT_ID.value, payload);
function* getNoiCalcByReportComponentIdSaga({ reportComponentId }) {
  const url = `/report-components/${reportComponentId}`;
  yield requestSaga(GET_NOI_CALC_BY_REPORT_COMPONENT_ID, url, "GET", null, null, null, true);
  yield put(SET_FIELD_UPDATED_FLAG.createSuccess(false));
}

export const actionCreators = {
  setNoiCalculationsDashboardSelections,
  getNoiCalcByReportComponentId,
  setDefaultNoiDashboardSelections
};

// REDUCER
const initialState = {
  adjustedExpenseLineItems: null,
  adjustedIncomeLineItems: null,
  initialDrawerSectionName: null,
  isAdjustedExpenseExpanded: false,
  isAdjustedIncomeExpanded: false,
  isDeleteDialogOpen: false,
  isLenderReportingDrawerOpen: false,
  addLineItemType: null,
  lineItems: [],
  totalAdjustedExpense: 0,
  totalAdjustedIncome: 0,
  totalAdjustedNoi: 0,
  lineItemToEdit: null,
  reportComponent: null,
  isMultipleProperties: false,
  fieldUpdated: false
};

export function lenderReportingNoiCalculationReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_NOI_CALC_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_DEFAULT_NOI_CALC_SELECTIONS.value:
      return defaultReturn({ ...initialState });

    case SET_FIELD_UPDATED_FLAG.success:
      return defaultReturn(state, payload, "fieldUpdated");

    case GET_NOI_CALC_BY_REPORT_COMPONENT_ID.value:
      return defaultReturn(state);
    case GET_NOI_CALC_BY_REPORT_COMPONENT_ID.success:
      return multipleObjectReturn(state, ["lineItems", "reportComponent"], [payload.data.lineItems.map(li => ({ ...li, isExpanded: false })), payload.data]);
    case GET_NOI_CALC_BY_REPORT_COMPONENT_ID.failure:
      ToastError("Failed to load existing report component");

      return defaultReturn(state, null, "lineItems");

    default:
      return state;
  }
}

// SAGA
export function* lenderReportingNoiCalculationSaga() {
  yield takeLatest(GET_NOI_CALC_BY_REPORT_COMPONENT_ID.value, getNoiCalcByReportComponentIdSaga);
}
